var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_9022",
    "data-name": "Gruppe 9022",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffc400;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2531",
    "data-name": "Pfad 2531",
    className: "cls-1",
    d: "M34.414,24.243,19.484,50.1a3.071,3.071,0,0,0,2.66,4.608H52a3.071,3.071,0,0,0,2.66-4.608L39.733,24.243a3.071,3.071,0,0,0-5.319,0Z",
    transform: "translate(-19.072 -22.708)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6281",
    "data-name": "Gruppe 6281",
    transform: "translate(16.07 9.51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2483",
    "data-name": "Rechteck 2483",
    className: "cls-2",
    width: 3.862,
    height: 11.77,
    rx: 1.931,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    className: "cls-2",
    cx: 1.931,
    cy: 1.931,
    rx: 1.931,
    ry: 1.931,
    transform: "translate(0 14.49)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.780e5a0be93cc25aed43f05d5a4abc81.svg";
export { ForwardRef as ReactComponent };